import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pt-12 md:px-6 md:pt-16">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-800 bg-background-900 p-5 transition-colors hover:border-accent-500/70 cursor-pointer md:p-6"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300 transition-colors group-hover:bg-accent-500 group-hover:text-background-950 md:h-16 md:w-16">
              <i className={`${cat.icon} text-2xl md:text-3xl`} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2">
                <span className="font-heading text-lg font-bold text-foreground-50 md:text-xl">
                  {cat.name}
                </span>
                <i className="ri-arrow-right-line text-base text-secondary-400 transition-transform group-hover:translate-x-1 group-hover:text-accent-400" />
              </span>
              <span className="mt-1 block truncate text-sm text-foreground-400">
                {cat.short}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}